<template>
  <el-container>
    <el-main>
      <el-row>
        <el-col :span="12">
          <span>操作日志</span>
        </el-col>
        <el-col :span="12" class="align-right">
          <el-button @click="$emit('exit')" size="small">{{$t('back')}}</el-button>
        </el-col>
      </el-row>
      
      <el-form
        ref="form"
        :model="content"
        label-position="top"
        label-width="180px"
        size="mini">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="操作人">
              <el-input type="text" v-model="content.operator"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="类型">
              <el-input type="text" v-model="content.type"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="描述">
              <el-input type="text" v-model="content.description"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="日期">
              <el-input type="text" v-model="content.date"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="ip">
              <el-input type="text" v-model="content.ip"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
export default {
  created() {
    this.content=JSON.parse(JSON.stringify(this.detail));
  },
  data() {
    return {
     content:{},
    };
  },
  props: ["detail"],
  computed: {
    
  },
  methods:{
    
    
  },
  watch:{
    detail(newVal){
      this.content=JSON.parse(JSON.stringify(newVal))
    },
    
  },

};
</script>

<style>
</style>